<template>
    <div class="cw-right-news">
        <header class="title">
            <span class="title-f">最新资讯</span>
            <!-- <span class="file-title-l">查看更多</span> -->
        </header>
        <footer class="news-content">
            <div class="news-content-item" v-for="item in list" :key="item" @click="handleWindowOpen(item.url)">{{item.title}}</div>
        </footer>
    </div>
</template>

<script>
import { getToWxGzh } from "@/api/msg/msg";

export default {


    data() {
        return {
            list: [],
        }
    },

    mounted() {
        getToWxGzh({
           currentPage:1,
           pageSize: 5
        }).then(res => {
            this.list = res.data.data
        })
    },

    methods:{
        handleWindowOpen(url) {
            window.open(url);
        }
    }
}

</script>

<style lang="scss" scoped>
.cw-right-news {
    padding: 0 14px;
    .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title-f {
            font-size: 18px;
            font-weight: 600;
            color: #333333;
            &::before {
                content: '';
                display: inline-block;
                width: 6px;
                height: 6px;
                margin-right: 10px;
                margin-bottom: 3px;
                border-radius: 100%;
                background: #84D9D5;
            }
        }
        .title-l {
            font-size: 15px;
            color: #999999;
            cursor: pointer;
            text-decoration:underline
        }
    }


    .news-content {
        margin-top: 10px;
    }
    .news-content-item {
        height: 31px;
        padding: 0 10px;
        margin-bottom: 10px;
        font-size: 13px;
        color: #666666;
        line-height: 31px;
        background: #FFFFFF;
        box-shadow: 0px 0px 4px 0px rgba(165,165,165,0.36);
        border-radius: 7px;
        white-space:nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>
